import type { MyItemsTarget } from './useDashboardStore';

export interface EffectiveTarget {
  effectiveUserId: string | undefined;
  isTargetGroup: boolean;
  targetGroupId: string | undefined;
}

/**
 * Resolves the dashboard target into the trio every filter/query consumer
 * needs:
 * - `effectiveUserId` — the id to use as "current user" in ownership filters.
 *   A user-target substitutes its id; a group-target or no-target falls back
 *   to the logged-in user.
 * - `isTargetGroup` — whether the target is a group; ownership filters use
 *   this to short-circuit user-level flags that can't apply to a group.
 * - `targetGroupId` — the id to use for group-membership predicates when
 *   `isTargetGroup` is true.
 *
 * Centralising this here keeps the substitution rule in one place; the
 * previous duplicated ternary lived in four hooks.
 */
export const resolveEffectiveTarget = (
  target: MyItemsTarget | null | undefined,
  fallbackUserId: string | undefined
): EffectiveTarget => ({
  effectiveUserId: target?.type === 'user' ? target.id : fallbackUserId,
  isTargetGroup: target?.type === 'group',
  targetGroupId: target?.type === 'group' ? target.id : undefined,
});
